<template>
  <b-modal
    v-model="showModal"
    id="modal-report-scheduler"
    :title="$t('report.title.downloadHistory')"
    class="mc-modal"
    size="lg"
    centered
    scrollable
    ok-variant="outline-primary"
    :ok-title="$t('global.action.close')"
    title-class="text-white"
    header-close-variant="light"
    ok-only
  >
    <div id="tickets-table_filter" class="dataTables_filter text-end">
      <label class="d-inline-flex align-items-center mc-table-view__search ms-2">
        <i class="mc-fa fas fa-search"></i>
        <b-form-input
          v-model="filter"
          type="search"
          :placeholder="$t('global.search') + '...'"
          class="ms-2"
          @input="onSearch"
        />
      </label>
    </div>

    <div class="table-responsive my-3 border border-1">
      <b-table
        :items="showReports"
        :fields="fields"
        empty-table
        show-empty
        :empty-text="$t('global.emptyTable')"
        :empty-filtered-text="$t('global.emptyFilteredTable')"
        class="datatables"
        sticky-header="400px"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle" />
          </div>
        </template>
        <template #cell(label)="data">
          <div class="d-flex align-items-center">
            <i
              v-if="hasAccessAll(['favorite-reports:update', 'favorite-reports:read'])"
              title="Jadikan Favorit"
              :class="`mc-fa icon-${data.item.isFavorite ? 'fill' : 'outline'}_star font-size-24`"
              @click="onFavorite(data.item.key)"
            ></i>
            <span class="ms-2 clickable-field" @click="onRowClick(data.item)">{{
              data.item.label
            }}</span>
          </div>
        </template>
        <template #cell(desc)="data">
          {{ $t(data.item.desc) }}
        </template>
      </b-table>
    </div>
  </b-modal>
</template>
<script>
import { Helper, debounce } from '@/mixin/helper'
import { GET_FAVORITE_REPORTS, UPDATE_FAVORITE_REPORTS } from '@/services/api/report/report'
import { mapGetters } from 'vuex'

export default {
  mixins: [Helper],
  apollo: {
    favoriteReports: {
      query: GET_FAVORITE_REPORTS,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            type: 'scheduler',
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const reportKeys = data.favoriteReports.favoriteReports.favoriteReportKeys
          this.favoriteReports = reportKeys
          return reportKeys
        }
      },
    },
  },
  props: {
    reportOptions: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      filteredItems: this.reportOptions,
      filter: null,
      showModal: false,
      reports: this.reportOptions,
      favoriteReports: [],
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    fields() {
      return [
        {
          key: 'label',
          label: this.$t('report.object.reportName'),
        },
        {
          key: 'desc',
          label: this.$t('report.object.description'),
        },
      ]
    },
    showReports() {
      const list = this.filteredItems.map((item) => {
        return {
          ...item,
          isFavorite: this.favoriteReports.includes(item.key),
        }
      })
      const ordering = (list) => {
        const copyList = [...list]
        copyList.sort((x, y) => {
          if (x.label < y.label) {
            return -1
          }
          if (x.label > y.label) {
            return 1
          }
          return 0
        })
        return copyList
      }
      const favorited = list.filter((item) => item.isFavorite)
      const notFavorited = list.filter((item) => !item.isFavorite)

      return ordering(favorited).concat(ordering(notFavorited))
    },
  },
  methods: {
    openModal() {
      this.showModal = true
    },
    async onFavorite(key) {
      if (this.hasAccess(['favorite-reports:update'])) {
        const report = this.showReports.find((item) => item.key === key)
        if (report.isFavorite) {
          this.favoriteReports = this.favoriteReports.filter((item) => item !== key)
        } else {
          this.favoriteReports.push(key)
        }
        await this.$apollo.mutate({
          mutation: UPDATE_FAVORITE_REPORTS,
          variables: {
            input: {
              reportKey: key,
              status: !report.isFavorite,
              type: 'scheduler',
            },
          },
          fetchPolicy: 'no-cache',
        })
      }
    },
    onSearch: debounce(function () {
      this.filteredItems = this.reports.filter((item) => {
        return (
          item.label.toLowerCase().includes(this.filter.toLowerCase()) ||
          this.$t(item.desc).toLowerCase().includes(this.filter.toLowerCase())
        )
      })
    }, 500),
    onRowClick(row) {
      this.$emit('onSelect', row.key)
      this.showModal = false
    },
  },
}
</script>
<style scoped lang="scss">
.icon-fill_star::before {
  color: #ff8a00 !important;
}
</style>
